import "./NeedHelp.scss";
import { useNavigate } from "react-router-dom";

const NeedHelp = () => {
  const navigate = useNavigate();
  return (
    <div id="need-help">
      <div>
        <div>
          <h1>ET SI VOUS AVEZ BESOIN D’AIDE</h1>
          <p>
            Si vous avez une question ou une demande spéciale, n’hésitez pas à
            nous appeler ou nous envoyer un message via notre formulaire.
          </p>
          <div className="info">
            <span>01 69 34 92 28</span>
            <span>info@sphygiene.com</span>
          </div>
          <button onClick={() => navigate("/contact")}>Nous écrire</button>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default NeedHelp;
